<template>
    <v-container>
        <v-row justify="center">
            <v-col v-if="partner" cols="12" xs="6" sm="6" md="6" lg="6" align="center">
                <v-select
                        :label="language=='Ελληνικά'? 'Κατηγορία' : 'Category'"
                        clearable
                        style="color:#1b2f5a !important;"
                        color="#1b2f5a"
                        :items="categories"
                        v-model="filter.category"
                        item-text="title"
                        item-value="id"
                ></v-select>
                <v-autocomplete
                    v-model="filter.title"
                    :items="titles"
                    color="#1b2f5a"
                    :label="language=='Ελληνικά'? 'Όνομα' : 'Name'"
                    style="color:#1b2f5a !important;"
                    menu-props="auto"
                    hide-details
                    single-line
                    clearable
                    return-object
                />
                <v-text-field
                    v-if="this.$route.path=='/Partners'"
                    class="my-10"
                    v-model="searchAddress"
                    prepend-inner-icon="mdi-map-marker"
                    append-outer-icon="mdi-send"
                    label="Πληκτρολόγησε την περιοχή που σε ενδιαφέρει"
                    clearable
                    style="color:#1b2f5a !important;"
                    @click:append-outer="getCoordinates"
                    @keyup.enter="getCoordinates"
                ></v-text-field>
                <v-btn outlined dark color="#ad282d" @click="resetFilters()">
                    <v-icon> mdi-close </v-icon>
                    {{language=='Ελληνικά'? 'Καθαρισμος φίλτρων' : 'Clear filters'}}
                </v-btn>
            </v-col>
            <v-col v-if="this.$route.path=='/Partners'" cols="12" xs="6" sm="6" md="6" lg="6" justify="center" align="center">
                <gmap-map
                    :center="center"
                    :zoom="zoom"
                    :options="options"
                    style="width:100%;  height: 300px;"
                >
                    <gmap-marker
                        v-for="(marker, index) in markers"
                        :key="index"
                        :position="marker.position"
                        :clickable="true"
                        @click="openMarker(marker.id)"
                    >
                        <gmap-info-window
                            :closeclick="true"
                            @closeclick="openMarker(null)"
                            :opened="openedMarkerID === marker.id"
                        >
                            <router-link :to="`/Partner?id=${marker.id}`"> {{`${marker.title} - ${marker.type}`}}</router-link>
                        </gmap-info-window>
                    </gmap-marker> 
                     <gmap-marker
                        :position="center"
                        :icon="{
                            url: require('@/assets/google-maps.gif'),
                            scaledSize: {width: 77, height: 77},
                            labelOrigin: {x: 16, y: -10}
                        }"
                     >
                     </gmap-marker>
                </gmap-map>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import restApi from "@/rest-api"
    import places from "@/services/places-api"

    export default {
        data() {
            return {
                filter:{
                    "available": true,
                    "approved": true,
                    "address": null,
                    "center": null
                },
                zoom: 17,
                partner: false,
                types: [],
                categories: [],
                addresses: [],
                titles: [],
                center: { lat: 37.9303581, lng: 23.7013619 },
                markers: [
                    {
                    }
                ],
                options: {
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: true,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUI: false
                },
                searchAddress: '',
                openedMarkerID: null,
            }
        },
        watch:{
            'filter.category': {
                handler() {
                    this.fetchFilters()
                    this.$emit('fetchData', this.filter)
                }
            },
            'filter.title': {
                handler() {
                    this.fetchFilters()
                    this.$emit('fetchData', this.filter)
                }
            },
            'filter.center': {
                handler() {
                    this.fetchFilters()
                    this.$emit('fetchData', this.filter)
                }
            }
        },
        created() {
            this.fetchFilters()
            this.$emit('fetchData',this.filter)
            this.$getLocation({}).then( coordinates => {
                this.center = coordinates
                // this.filter.center = coordinates.lat + ',' + coordinates.lng
            })
        },
        computed: {
            language() {
                return this.$store.getters.getLanguage.language
            }
        },
        methods: {
            getCategories() {
                var search = `/partner/categories?b2b=true&`;
                if(this.filter.title) {
                    search += 'title='+ this.filter.title + '&'
                } 
                if(this.filter.center) {
                    search += 'address='+ this.filter.center
                }
                restApi
                .get(search)
                .then(response => {
                    this.categories = response
                })
                .catch((error) => {
                    console.log(error)
                });
            },
            // submitFilters() {
            //     if(this.$route.path==="/Partners"){
            //         this.fetchFilters()
            //     }
            //     this.$emit('fetchData',this.filter)
            // },
            openMarker(id) {
                this.openedMarkerID = id
            },
            fetchFilters() {
                this.fetchMapAddresses()
                this.fetchTitles()
                this.getCategories()
                this.partner = true
            },
            resetFilters() {
                this.filter = {}
                this.searchAddress = ''
            },
            fetchMapAddresses() {
                var search = `/partner/map/addresses?b2b=true&`;
                if(this.filter.title) {
                    search += 'title='+ this.filter.title + '&'
                } 
                if(this.filter.center) {
                    search += 'address='+ this.filter.center + '&'
                } 
                if(this.filter.category) {
                    search += 'category='+ this.filter.category + '&'
                }
                restApi
                .get(search)
                .then(response => {
                    this.markers = response.map( function (address) {
                        if (address.coordinates) {
                            var coordinates = address.coordinates.split(',')
                            return {
                                position: {
                                    lat: parseFloat(coordinates[0]),
                                    lng: parseFloat(coordinates[1])
                                },
                                id: address.id,
                                title: address.title,
                                type: address.type
                            }
                        } else {
                            return {
                                position: {
                                    lat: 0,
                                    lng: 0
                                },
                                id: address.id,
                                title: address.title,
                                type: address.type
                            }
                        }
                    })
                })
                .catch((error) => {
                    console.log(error);
                })
            },
            fetchTitles() {
                var search = `/partner/titles?b2b=true&`;
                if(this.filter.center) {
                    search += 'address='+ this.filter.center + '&'
                } 
                if(this.filter.category) {
                    search += 'category='+ this.filter.category
                }
                restApi
                .get(search)
                .then(response => {
                    this.titles = response.data.map(partner => partner.title);
                })
                .catch((error) => {
                    console.log(error);
                });
            },
            getCoordinates() {
                places.searchPlace(this.searchAddress)
                .then(resp => {
                    this.searchAddress = resp.candidates[0].formatted_address
                    this.center = { lat: resp.candidates[0].geometry.location.lat, lng: resp.candidates[0].geometry.location.lng }
                    this.zoom = 14
                    this.filter.address = ''
                    this.filter.center = resp.candidates[0].geometry.location.lat + ',' + resp.candidates[0].geometry.location.lng
                })
                .catch(error => { 
                    console.log(error)
                })
            }
        }
    }
</script>

<style lang="scss">
.v-icon {
    color: #1b2f5a !important;
}
.v-list-item__content {
  color: #1b2f5a !important;
}

.v-select__selection,
.v-select__selection--comma,
.v-select.v-text-field input {
    color: #1b2f5a !important;
}
</style>
